module.exports = __webpack_public_path__ + "static/img/beijing2.2d5989e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/beijing2.png
// module id = xWhH
// module chunks = 1